export const NURSE_DEPLOYMENT_TYPE_NURSE = 'nurse'; // BK
export const NURSE_DEPLOYMENT_TYPE_PAUSE = 'pause'; // Pause Kostenlos
export const NURSE_DEPLOYMENT_TYPE_PAUSE_FEE_BASED = 'pause_fee_based'; // Pause Kostenpflichtig
export const NURSE_DEPLOYMENT_TYPE_CANCELLATION = 'cancellation_period'; // Kündigungsfrist
